import React, { Component } from "react";
import { Link } from "react-router-dom";
import { truncateText, formatDate, imageUrl, apiUrl, formatDateAndTimeFromString } from "../util";
import * as querystring from "querystring";
import request from "request";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil";
import SendToCMS from "../components/SendToCMS";
import SendToProblemQueue from "../components/SendToProblemQueue";
import SplitQueueControl from "../components/SplitQueueControl";
import BrowserBadge from "../components/BrowserBadge";
import ProbablyNotTestBadge from "../components/ProbablyNotTestBadge";
import BrokenCaptureBadge from "../components/BrokenCaptureBadge";
import { isBrowserCapture } from "../util/splitQueue";

const ZOOM_LEVEL = [
  {
    label: "In",
    value: "in",
  },
  {
    label: "Mid",
    value: "mid",
  },
  {
    label: "Out",
    value: "out",
  },
];
class UrlScreenShots extends Component {
  constructor(props) {
    super(props);
    const qs = querystring.parse(window.location.search.replace("?", ""));
    this.state = {
      screenshots: null,
      filterBy: qs.filterBy ? qs.filterBy : "all",
      qid: qs.qid,
      start_date: qs.start_date,
      end_date: qs.end_date,
      zoom: qs.zoom || "out",
      items: [],
      lookback: Number(qs.lookback) || 2,
      load: 25,
      loading: true,
      loadingQueueStats: true,
      end_tests: {},
      start_tests: {},
      showTimeline: true,
    };
  }
  componentDidMount() {
    const { url } = this.props.match.params;
    if (url) {
      this.getData();
      this.getQueueData()
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.cleanupGetQueueDataPolling) {
      this.cleanupGetQueueDataPolling();
      this.cleanupGetQueueDataPolling = null;
    }
  }
  interval: null;
  cleanupGetQueueDataPolling = null;
  queueDataPollingPromise = null;
  loadImages = () => {
    this.interval = setInterval(() => {
      this.setState({
        load: this.state.load + 25,
      });
    }, 150);
  };
  countImages = screens => {
    let cnt = 0;

    screens.forEach(screen => {
      cnt += Object.keys(screen.comparison).length;
    });

    return cnt;
  };
  getData = () => {
    const { url } = this.props.match.params;
    const { lookback } = this.state;
    request(
      `${apiUrl}/v1/admin/v2/getScreenShotsForUrl?url=${url}&lookback=${lookback}`,
      {
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        const json = JSON.parse(data);
        json.screens.sort((a, b) => (a.ctime >= b.ctime ? -1 : 1));
        json.screens.forEach(screen => {
          Object.keys(screen.comparison).forEach(c => {
            const file = screen.fileLocations
              ? screen.fileLocations.find(ss => c === ss.split("/").pop())
              : null;
            if (c.endsWith(".png") || c.endsWith(".jpg")) {
              screen.comparison[c].shot = file;
            }
          });
          const ordered = {};
          Object.keys(screen.comparison)
            .sort((a, b) => {
              if (screen.comparison[a].weight && screen.comparison[b].weight) {
                return Number(screen.comparison[a].weight) >=
                  Number(screen.comparison[b].weight)
                  ? -1
                  : 1;
              }
            })
            .forEach(key => {
              ordered[key] = screen.comparison[key];
            });
          screen.comparison = ordered;
        });
        this.setState({
          loading: false,
          screenshots: json.screens,
          items: json.items || [],
          urlInfo: Array.isArray(json.url) ? json.url[0] : json.url,
          end_tests: json.by_date.end,
          start_tests: json.by_date.start,
        });
        this.loadImages();
        const hash = window.location.hash;
        window.location.hash = "";
        setTimeout(() => {
          window.location.hash = hash;
        }, 1000);
      }
    );
  };
  getQueueData = () => {
    const { url } = this.props.match.params;
    const { lookback } = this.state;
    if (this.cleanupGetQueueDataPolling) {
      this.cleanupGetQueueDataPolling();
      this.cleanupGetQueueDataPolling = null;
    }

    this.setState({ loadingQueueStats: true });

    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.queueDataPollingPromise = pollingPromise;
    this.cleanupGetQueueDataPolling = cleanup;
    const pollingData = {
      url,
      lookback,
    };

    this.queueDataPollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "getQueueStatsForUrl",
        clearCache: true,
        data: JSON.stringify(pollingData),
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "getQueueStatsForUrl",
        data: JSON.stringify(pollingData),
      },
      token: this.props.user.token,
    })
      .then(json => {
        if (json && Array.isArray(json.items)) {
          json.items.sort((a, b) => (a.ctime >= b.ctime ? -1 : 1));
        }
        this.setState({
          loadingQueueStats: false,
          queueStatsItems: (json && json.items) || [],
        });

        if (this.cleanupGetQueueDataPolling) {
          this.cleanupGetQueueDataPolling();
          this.cleanupGetQueueDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching queue stats:", err);
        this.setState({
          loadingQueueStats: false,
          queueStatsItems: [],
        });
      });
  };
  handleClick = e => {
    e.preventDefault();
    this.setState({
      filterBy: e.currentTarget.innerHTML.trim(),
    });
    this.loadImages();
  };
  handleZoom = zoom => e => {
    e.preventDefault();
    this.setState({
      zoom,
    });
  };
  handleLookback = lb => e => {
    e.preventDefault();
    this.setState(
      {
        lookback: lb,
        loading: true,
      },
      ()=>{
        this.getData();
        this.getQueueData();
      });
  };
  prevMobileCount = null;
  prevDesktopCount = null;
  getZoomLevelClass(componentType, zoomLevel) {
    const ZOOM_LEVEL_CLASSES = {
      URL_HEADING: {
        in: "f1",
        mid: "f2",
        out: "f3",
      },
      SCREEN_CONTAINER_MB: {
        in: "1rem",
        mid: ".62rem",
        out: ".25rem",
      },
      SCREEN_CONTAINER_CLASS: {
        in: "f5",
        mid: "f6",
        out: "f8",
      },
      SCREEN_CONTAINER_HEADING: {
        in: "f3",
        mid: "f5",
        out: "f8",
      },
      SCREEN_IMAGE_WIDTH: {
        in: "300",
        mid: "125",
        out: "25",
      },
    };
    return ZOOM_LEVEL_CLASSES[componentType] &&
      ZOOM_LEVEL_CLASSES[componentType][zoomLevel]
      ? ZOOM_LEVEL_CLASSES[componentType][zoomLevel]
      : "";
  }
  getScreenAnchorId = ctime => `screen-${ctime.replace(/[:.]/g, "-")}`;
  formatDateTime = ctime => {
    const d = new Date(ctime);
    return Number.isNaN(d.getTime()) ? ctime : d.toLocaleString();
  };
  getMonthsDifference = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      (d2.getFullYear() - d1.getFullYear()) * 12 +
      (d2.getMonth() - d1.getMonth())
    );
  };
  findAppropiateLookback = monthsAgo => {
    const lookbackOptions = [2, 4, 6, 9, 14, 18];
    const appropriate = lookbackOptions.find(option => option >= monthsAgo);
    return appropriate || Math.ceil(monthsAgo);
  };
  handleTimelineClick = (e, test) => {
    e.preventDefault();
    const { screenshots } = this.state;
    const testDate = test.ctime.substring(0, 10);
    
    // Check if screen exists with matching date
    const screenExists = screenshots && screenshots.some(
      screen => screen.ctime.substring(0, 10) === testDate
    );
    
    if (screenExists) {
      // Screen exists, navigate to it
      const anchorId = this.getScreenAnchorId(test.ctime);
      window.location.hash = anchorId;
    } else {
      // Screen doesn't exist, calculate required lookback
      const monthsAgo = this.getMonthsDifference(test.ctime, new Date());
      const requiredLookback = this.findAppropiateLookback(monthsAgo);
      
      // Only reload if we need more lookback than current
      if (requiredLookback > this.state.lookback) {
        this.setState(
          {
            lookback: requiredLookback,
            loading: true,
            // loadingQueueStats: true,
          },
          () => {
            this.getData();
            // this.getQueueData();
            // After data loads, navigate to the item
            setTimeout(() => {
              const anchorId = this.getScreenAnchorId(test.ctime);
              window.location.hash = anchorId;
            }, 1500);
          }
        );
      }
    }
  };
  render() {
    const {
      screenshots,
      filterBy,
      zoom,
      items,
      loading,
      lookback,
      start_date,
      end_date,
      urlInfo,
      end_tests,
      start_tests,
      showTimeline,
      queueStatsItems,
      loadingQueueStats,
    } = this.state;
    const url = decodeURIComponent(this.props.match.params.url);

    let screens = screenshots;

    let imgCnt = 0;

    if (screens) {
      if (filterBy === "mobile") {
        screens = screenshots.filter(screen => screen.isMobile);
      } else if (filterBy === "desktop") {
        screens = screenshots.filter(screen => !screen.isMobile);
      }
      if (this.state.load >= this.countImages(screens)) {
        clearInterval(this.interval);
      }
    }

    if (loading) {
      return <h1>Loading...</h1>;
    }

    return (
      <div>
        {(loadingQueueStats || (queueStatsItems && queueStatsItems.length > 0)) && (
          <div
            className={`fixed top-0 right-0 mt2 mr2 bg-white br2 ba b--light-gray shadow-2 z-999 ${
              showTimeline ? "w5 pa2" : "w2 pa1"
            }`}
            style={{ maxHeight: "70vh", display: "flex", flexDirection: "column" }}
          >
            <div
              className="flex justify-between bg-white pb2 bb b--light-gray"
              style={{ flexShrink: 0 }}
            >
              {showTimeline && <strong>Timeline</strong>}
              <button
                onClick={() =>
                  this.setState({ showTimeline: !this.state.showTimeline })
                }
                className="bn bg-transparent pointer f6"
                aria-label={showTimeline ? "Minimize" : "Expand"}
                title={showTimeline ? "Minimize" : "Expand"}
              >
                {showTimeline ? "–" : "+"}
              </button>
            </div>
            {showTimeline && loadingQueueStats && (
              <div className="mt2 gray">Loading…</div>
            )}
            {showTimeline && !loadingQueueStats && (
              <div style={{ overflowY: "auto", flex: 1 }}>
                <ul className="list pl0 ma0 mt2">
                  {queueStatsItems.map(test => {
                    const anchorId = this.getScreenAnchorId(test.ctime);
                    const typeLabel = test.type === "started_test" 
                      ? "started" 
                      : test.type === "ended_test" 
                      ? "ended" 
                      : test.type;
                    return (
                      <li key={test.ctime} className="mb2">
                        <a 
                          href={`#${anchorId}`} 
                          className="dark-red no-underline pointer"
                          onClick={(e) => this.handleTimelineClick(e, test)}
                        >
                          <div className="f7 gray mb1">{typeLabel}</div>
                          <div>{formatDateAndTimeFromString(test.ctime)}</div>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        )}
        <h1 className={this.getZoomLevelClass("URL_HEADING", zoom)}>
          <a href={url}>{truncateText(url, 50)}</a>
        </h1>
        <p className="sticky-bar pv2">
          <b>Show: </b>
          <>
            <a
              href={filterBy !== "all" ? "#" : null}
              onClick={this.handleClick}
            >
              all
            </a>{" "}
            |{" "}
          </>
          <a
            href={filterBy !== "mobile" ? "#" : null}
            onClick={this.handleClick}
          >
            mobile
          </a>{" "}
          |{" "}
          <a
            href={filterBy !== "desktop" ? "#" : null}
            onClick={this.handleClick}
          >
            desktop
          </a>{" "}
          &middot; <b className="ml1">Zoom:</b>{" "}
          {ZOOM_LEVEL.map((zoomLevel, index) => {
            return (
              <>
                {zoom === zoomLevel.value ? (
                  zoomLevel.label
                ) : (
                  <a href="#" onClick={this.handleZoom(zoomLevel.value)}>
                    {zoomLevel.label}
                  </a>
                )}
                {index < ZOOM_LEVEL.length - 1 && ` | `}
              </>
            );
          })}{" "}
          &middot;{" "}
          <span className="ml1">
            <a href="#mobile-split">mobile split start</a> |{" "}
            <a href="#desktop-split">desktop split start</a>
          </span>{" "}
          &middot; <b>Look back: </b>{" "}
          {lookback !== 2 ? (
            <a href="#" onClick={this.handleLookback(2)}>
              2 months
            </a>
          ) : (
            <>2 months</>
          )}{" "}
          |{" "}
          {lookback !== 4 ? (
            <a href="#" onClick={this.handleLookback(4)}>
              4 months
            </a>
          ) : (
            <>4 months</>
          )}{" "}
          |{" "}
          {lookback !== 6 ? (
            <a href="#" onClick={this.handleLookback(6)}>
              6 months
            </a>
          ) : (
            <>6 months</>
          )}{" "}
          |{" "}
          {lookback !== 9 ? (
            <a href="#" onClick={this.handleLookback(9)}>
              9 months
            </a>
          ) : (
            <>9 months</>
          )}{" "}
          |{" "}
          {lookback !== 14 ? (
            <a href="#" onClick={this.handleLookback(14)}>
              14 months
            </a>
          ) : (
            <>14 months</>
          )}{" "}
          |{" "}
          {lookback !== 18 ? (
            <a href="#" onClick={this.handleLookback(18)}>
              18 months
            </a>
          ) : (
            <>18 months</>
          )}
          {(start_date || end_date) && (
            <p>
              {start_date && (
                <a href={`#${start_date}`}>Go to test start date</a>
              )}
              {start_date && end_date && <> | </>}
              {end_date && <a href={`#${end_date}`}>Go to test end date</a>}
            </p>
          )}
        </p>
        <div className="flex flex-wrap items-center justify-between">
          <h3 className="mb3">
            Country:{" "}
            <span style={{ textTransform: "uppercase" }}>
              {urlInfo ? urlInfo.location || "US" : "US"}
            </span>
          </h3>
          <SplitQueueControl user={this.props.user} url={url} />
        </div>

        <div className="mb3">
          <SendToProblemQueue
            user={this.props.user}
            url={url}
            platform={this.state.filterBy}
            qid={this.state.qid}
            urlInfo={urlInfo}
            callback={()=> {
              this.getData(); 
              this.getQueueData()
            }}
          />
        </div>
        {items && items.length !== 0 && (
          <div>
            <h3 className="f3">
              <Link to={`/screens/${this.props.match.params.url}/tests`}>
                {items.length} {items.length === 1 ? "test" : "tests"} currently
                published or in queues
              </Link>
            </h3>
          </div>
        )}
        {screens && (
          <>
            {screens.map((screen, i) => {
              const date = formatDate(screen.ctime);
              const lookup_date = screen.ctime.substring(0, 10);
              const nextItem = i < screens.length - 1 ? screens[i + 1] : null;
              const prevItem = i !== 0 ? screens[i - 1] : null;
              const nextDate = nextItem ? formatDate(nextItem.ctime) : null;
              const prevDate = prevItem ? formatDate(prevItem.ctime) : null;
              const prevMobile = prevItem ? prevItem.isMobile : null;
              const nextMobile = nextItem ? nextItem.isMobile : null;
              const count = Object.keys(screen.comparison).length;
              const foundSplit = screen.isMobile
                ? this.prevMobileCount === 1 && count > 1
                : this.prevDesktopCount === 1 && count > 1;

              let foundSplitId = "";

              if (foundSplit && screen.isMobile) {
                foundSplitId = "mobile-split";
              } else if (foundSplit && !screen.isMobile) {
                foundSplitId = "desktop-split";
              }

              if (screen.isMobile) {
                this.prevMobileCount = count;
              } else {
                this.prevDesktopCount = count;
              }

              return (
                <div
                  id={this.getScreenAnchorId(screen.ctime)}
                  style={{
                    marginBottom: this.getZoomLevelClass(
                      "SCREEN_CONTAINER_MB",
                      zoom
                    ),
                    width:
                      (nextDate === date && screen.isMobile !== nextMobile) ||
                      (prevDate === date && screen.isMobile !== prevMobile)
                        ? "50%"
                        : "100%",
                    display: "inline-block",
                  }}
                  key={screen.ctime}
                  className={this.getZoomLevelClass(
                    "SCREEN_CONTAINER_CLASS",
                    zoom
                  )}
                >
                  {foundSplitId && <div id={foundSplitId} className="h0" />}
                  <div
                    id={screen.ctime.substring(0, 10)}
                    className="pt2"
                  />
                  <h3
                    className={this.getZoomLevelClass(
                      "SCREEN_CONTAINER_HEADING",
                      zoom
                    )}
                    id={date}
                  >
                    {date}{" "}
                    {screen.hasSplitTest && (
                      <span>{screen.flagSplit ? "⚠️" : "✅"}</span>
                    )}{" "}
                    &middot; {screen.runCount} &middot;{" "}
                    {screen.isMobile ? "📱" : "️💻"}
                    {isBrowserCapture(screen) && (
                      <span className="ml2">
                        &middot;
                        <BrowserBadge className="ml2" />
                      </span>
                    )}
                    {screen.probablyNotATest && (
                      <span className="ml2">
                        &middot;
                        <ProbablyNotTestBadge
                          className="ml2"
                          summary={screen.checkSummary}
                        />
                      </span>
                    )}
                    {urlInfo && urlInfo.landingPage && (
                      <span className="ml2">
                        &middot;
                        <span className="ml2">Landing Page</span>
                      </span>
                    )}
                    {start_tests[lookup_date] && (
                      <span className="ml2">
                        &middot;
                        <span className="ml2 green">Test started</span>
                      </span>
                    )}
                    {end_tests[lookup_date] && (
                      <span className="ml2">
                        &middot;
                        <span className="ml2 green">Test ended</span>
                      </span>
                    )}
                  </h3>
                  <Link
                    to={`/ss/${screen.id}/${screen.ctime}?expand=true&qid=${this.state.qid}`}
                    className="ssLink"
                  >
                    View larger screenshots
                  </Link>
                  <span style={{ marginLeft: "6px" }}>
                    <SendToCMS
                      id={screen.id}
                      ctime={screen.ctime}
                      qid={this.state.qid}
                    />
                    <SendToProblemQueue
                      user={this.props.user}
                      url={screen.url}
                      platform={screen.isMobile ? "mobile" : "desktop"}
                      qid={this.state.qid}
                      sid={screen.id}
                    />
                  </span>
                  <div style={{ display: "flex" }}>
                    {Object.keys(screen.comparison).map(s => {
                      const ss = screen.comparison[s];
                      // Set when the capture check found this screen broken.
                      const broken = ss.brokenCapture;
                      const sameAs =
                        broken && broken.sameAs
                          ? screen.comparison[broken.sameAs]
                          : null;
                      imgCnt++;
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            flexShrink: 1,
                            padding: "0 .5em",
                          }}
                          key={s}
                        >
                          <div>{ss.weight}%</div>
                          <a href={ss.shot} target="_blank">
                            {imgCnt < this.state.load && (
                              <img
                                src={imageUrl(ss.shot, 150, 0)}
                                width={this.getZoomLevelClass(
                                  "SCREEN_IMAGE_WIDTH",
                                  zoom
                                )}
                                style={
                                  broken
                                    ? { outline: "2px solid #ffb700" }
                                    : undefined
                                }
                              />
                            )}
                          </a>
                          {/* Below the image, so a run's images stay in line. */}
                          {broken && (
                            <div
                              className="center mt1"
                              style={{
                                maxWidth: `${this.getZoomLevelClass(
                                  "SCREEN_IMAGE_WIDTH",
                                  zoom
                                )}px`,
                              }}
                            >
                              <BrokenCaptureBadge
                                capture={broken}
                                sameAsWeight={sameAs ? sameAs.weight : null}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  }
}

export default UrlScreenShots;
